import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { CHART_COLORS, CHART_COLORS_THREE, productColors } from 'constant/variables';

am4core.useTheme(am4themes_animated);

export default function BulletPie(props) {
    const [viewData, setViewData] = useState([]);
    const { regionsale } = props;
    useEffect(() => {
        if (regionsale) {
            if (regionsale.length === 0) {
                const viewDetail = [];
                const details = {
                    country: "Data Not Available",
                    units: 0,
                    second: 0
                };
                viewDetail.push(details);
                setViewData(viewDetail);
            } else {
                const clinic = regionsale;
                const viewDetail = [];
                for (let index = 0; index < clinic.length; index++) {
                    const details = {
                        "country": clinic[index].Region,
                        "units": clinic[index].TotalSales,
                        "pie": [{
                            "value": clinic[index].BaqatiSales,
                            "title": "Baqati",
                            target: clinic[index].BaqatiTarget,
                            achieved_percentage: clinic[index].BaqatiAchievedPercentage,
                            color: productColors.Baqati
                        }, {
                            "value": clinic[index].HayyakSales,
                            "title": "Hayyak",
                            target: clinic[index].HayyakTarget,
                            achieved_percentage: clinic[index].HayyakAchievedPercentage,
                            color: productColors.Hayyak
                        }, {
                            "value": clinic[index].HBBSales,
                            "title": "HBB",
                            target: clinic[index].HBBTarget,
                            achieved_percentage: clinic[index].HBBAchievedPercentage,
                            color: productColors.HBB
                        }, {
                            "value": clinic[index].UpgradeSales,
                            "title": "Upgrade",
                            target: clinic[index].UpgradeTarget,
                            achieved_percentage: clinic[index].UpgradeAchievedPercentage,
                            color: productColors.Upgrade
                        }]
                    }
                    viewDetail.push(details);
                }

                setViewData(viewDetail);
            }
        }
    }, [regionsale]);

    const gotoOutletChart = (ev) => {
        const columnData = ev.target._dataItem?._dataContext || {};
        console.log("clicked on ", ev.target, columnData.country);
        props.onSelect(columnData.country);
        document.getElementById('outletProductChartId').scrollIntoView({
            behavior: 'smooth'
          })
    }

    useLayoutEffect(() => {
        var chart = am4core.create("chartdiv345", am4charts.XYChart);

        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        // Add data
        chart.data = viewData
        // chart.data = [{
        //     "country": "Lithuania",
        //     "units": 500,
        //     "pie": [{
        //         "value": 250,
        //         "title": "Cat #1"
        //     }, {
        //         "value": 150,
        //         "title": "Cat #2"
        //     }, {
        //         "value": 100,
        //         "title": "Cat #3"
        //     }]
        // }, {
        //     "country": "Czechia",
        //     "units": 300,
        //     "pie": [{
        //         "value": 80,
        //         "title": "Cat #1"
        //     }, {
        //         "value": 130,
        //         "title": "Cat #2"
        //     }, {
        //         "value": 90,
        //         "title": "Cat #3"
        //     }]
        // }, {
        //     "country": "Ireland",
        //     "units": 30,
        //     "pie": [{
        //         "value": 75,
        //         "title": "Cat #1"
        //     }, {
        //         "value": 55,
        //         "title": "Cat #2"
        //     }, {
        //         "value": 70,
        //         "title": "Cat #3"
        //     }]
        // }];

        // Modify chart's colors
        chart.colors.list = [am4core.color("#499ed6").lighten(0.7)];

        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "country";
        categoryAxis.renderer.grid.template.disabled = true;

        categoryAxis.renderer.labels.template.events.on("hit", gotoOutletChart);

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "Units sold (M)";
        valueAxis.min = 0;
        valueAxis.renderer.baseGrid.disabled = true;
        valueAxis.renderer.grid.template.strokeOpacity = 0.07;

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "units";
        series.dataFields.categoryX = "country";
        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.events.on("hit", gotoOutletChart, this);

        var fillModifier = new am4core.LinearGradientModifier();
        fillModifier.brightnesses = [0.6, 0, 0, 0.6];
        fillModifier.offsets = [0, 0.45, 0.55, 1];
        fillModifier.gradient.rotation = 0;
        series.columns.template.fillModifier = fillModifier;

        var columnTemplate = series.columns.template;
        // add tooltip on column, not template, so that slices could also have tooltip
        columnTemplate.column.tooltipText = "Series: {name}\nRegion: {categoryX}\nSales: {valueY}";
        columnTemplate.column.tooltipY = 0;
        columnTemplate.column.cornerRadiusTopLeft = 20;
        columnTemplate.column.cornerRadiusTopRight = 20;
        columnTemplate.strokeOpacity = 0;


        // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
        // columnTemplate.adapter.add("fill", function (fill, target) {
        //     var color = chart.colors.getIndex(target.dataItem.index * 3);
        //     return color;
        // });

        // create pie chart as a column child
        var pieChart = series.columns.template.createChild(am4charts.PieChart);
        pieChart.width = am4core.percent(80);
        pieChart.height = am4core.percent(80);
        pieChart.align = "center";
        pieChart.valign = "middle";
        pieChart.dataFields.data = "pie";

        var pieSeries = pieChart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "title";
        pieSeries.labels.template.disabled = true;
        pieSeries.ticks.template.disabled = true;
        pieSeries.slices.template.strokeWidth = 1;
        // pieSeries.slices.template.tooltipText = "Product: {title}\nTarget Sales: {target}\nTotal Sales: {value}\nAchieved %: {achieved_percentage}%";
        pieSeries.slices.template.tooltipText = "Product: {title}\nSales: {value}\nTarget: {target}\nAchievement: {achieved_percentage}%";
        pieSeries.slices.template.propertyFields.fill = "color";

        pieSeries.hiddenState.properties.startAngle = -90;
        pieSeries.hiddenState.properties.endAngle = 270;

        // this moves the pie out of the column if column is too small
        pieChart.adapter.add("verticalCenter", function (verticalCenter, target) {
            var point = am4core.utils.spritePointToSprite({ x: 0, y: 0 }, target.seriesContainer, chart.plotContainer);
            point.y -= target.dy;

            if (point.y > chart.plotContainer.measuredHeight - 15) {
                target.dy = -target.seriesContainer.measuredHeight - 15;
            }
            else {
                target.dy = 0;
            }
            return verticalCenter
        })

        return () => {
            chart.dispose();
        };
    }, [viewData]);

    return <div id="chartdiv345" style={{ width: '100%', height: '500px' }} />;
}
